import React, { useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import { FaOilCan, FaCoins, FaGem, FaFire } from 'react-icons/fa';
import { useAppContext } from "../context/AppContext";
import TradingChartXY from "./tradingchart";

// --- NAYA PROFESSIONAL X-Y AXIS CHART ---


export default function MarketTable() {


  return (
    <div className="w-full grid grid-cols-1  items-center">
      
      {/* LEFT: Asset Table */}
      <div className="lg:col-span-6 bg-white border border-slate-100 rounded-[2.5rem] shadow-2xl shadow-slate-200/50 overflow-hidden">
         
        <TradingChartXY />
        
      </div>

   

    </div>
  );
}